import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: '10px',
      overflow: 'hidden',
    },
    titlehead: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'white',
    },
    cardStyle: {
      borderRadius: 10,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    titleText: {
      fontSize: 17,
      textAlign: 'center',
      textTransform: 'uppercase',
      fontFamily: 'Poppins',
      fontWeight: 600,
    },
    titleContent: {
      fontSize: 17,
      lineHeight: '25px',
    },
    cardFooter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px 24px',
      // Override MUI CardActions defaults so the button can be full-width
      '&.MuiCardActions-root': {
        padding: '16px 24px',
      },
    },
    learnMoreButton: {
      width: '100%',
      height: 40,
      border: '1px solid #d8d8d8',
      borderRadius: 8,
      backgroundColor: '#ffffff',
      color: '#000b33',
      fontFamily: "'Open Sans SemiBold', sans-serif",
      fontSize: 14,
      letterSpacing: '0.28px',
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      '&:hover': {
        backgroundColor: '#f9f9f9',
      },
    },
    learnMoreArrow: {
      width: 16,
      height: 16,
    },
    cardContent: {
      margin: '47px 0px 10px 0px',
      padding: '0px 25px 0px !important',
      position: 'relative',
    },
    textFLoating: {
      fontSize: '11px',
      marginTop: '20px',
      marginLeft: '3px',
    },
    positionCircular: {
      position: 'absolute',
      top: '-110px',
      right: '30px',
      background: 'white',
      borderRadius: '50%',
    },
    limitText: {
      '@media only screen and (max-width: 600px)': {
        '-webkit-line-clamp': 5,
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
      },
    },
    noLimit: {
      '@media only screen and (max-width: 600px)': {
        display: 'block',
      },
    },
  })
);
